import { render, staticRenderFns } from "./match-list.vue?vue&type=template&id=766abd7e&scoped=true&"
import script from "./match-list.vue?vue&type=script&lang=js&"
export * from "./match-list.vue?vue&type=script&lang=js&"
import style0 from "./match-list.vue?vue&type=style&index=0&id=766abd7e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766abd7e",
  null
  
)

export default component.exports